<script>
export default {
    name: 'FlagUSA'
}
</script>
<template>
    <svg
        class="base-flag flag-u-s-a"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="28"
        height="20"
        viewBox="0 0 28 20"
    >
        <defs>
            <path id="a" d="M0 0h28v20H0z" />
            <path
                id="d"
                d="M10 6.667A.667.667 0 1110 8a.667.667 0 010-1.333zm-2.667 0a.666.666 0 11.002 1.332.666.666 0 01-.002-1.332zm-2.666 0a.666.666 0 110 1.332.666.666 0 010-1.332zM2 6.667A.667.667 0 112 8a.667.667 0 010-1.333zm1.333-1.334a.667.667 0 110 1.334.667.667 0 010-1.334zm2.667 0a.667.667 0 11-.001 1.335A.667.667 0 016 5.333zm2.667 0a.667.667 0 11-.001 1.333.667.667 0 01.001-1.333zM10 4a.667.667 0 110 1.334A.667.667 0 0110 4zM7.333 4a.666.666 0 11.002 1.332A.666.666 0 017.333 4zM4.667 4a.666.666 0 110 1.332.666.666 0 010-1.332zM2 4a.667.667 0 110 1.334A.667.667 0 012 4zm1.333-1.333a.666.666 0 11.002 1.332.666.666 0 01-.002-1.332zm2.667 0A.667.667 0 116 4a.667.667 0 010-1.333zm2.667 0a.666.666 0 110 1.332.666.666 0 010-1.332zM2 1.333a.667.667 0 11-.001 1.335A.667.667 0 012 1.333zm2.667 0a.667.667 0 11-.001 1.333.667.667 0 01.001-1.333zm2.666 0a.667.667 0 110 1.334.667.667 0 010-1.334zm2.667 0a.667.667 0 11-.001 1.335A.667.667 0 0110 1.333z"
            />
            <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
                <stop offset="0%" stop-color="#FFF" />
                <stop offset="100%" stop-color="#F0F0F0" />
            </linearGradient>
            <filter
                id="c"
                width="110.7%"
                height="130%"
                x="-5.4%"
                y="-7.5%"
                filterUnits="objectBoundingBox"
            >
                <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
                <feColorMatrix
                    in="shadowOffsetOuter1"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                />
            </filter>
        </defs>
        <g fill="none" fill-rule="evenodd">
            <mask id="b" fill="#fff"><use xlink:href="#a" /></mask>
            <use fill="#FFF" xlink:href="#a" />
            <path
                fill="#D02F44"
                d="M28 18.667V20H0v-1.333h28zM28 16v1.333H0V16h28zm0-2.667v1.334H0v-1.334h28zm0-2.666V12H0v-1.333h28zM28 8v1.333H0V8h28zm0-2.667v1.334H0V5.333h28zm0-2.666V4H0V2.667h28zM28 0v1.333H0V0h28z"
                mask="url(#b)"
            />
            <path fill="#46467F" d="M0 0h12v9.333H0z" mask="url(#b)" />
            <g mask="url(#b)">
                <use fill="#000" filter="url(#c)" xlink:href="#d" />
                <use fill="url(#e)" xlink:href="#d" />
            </g>
        </g>
    </svg>
</template>
